import css from 'styled-jsx/css';

const style = css`
  .day-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .day-title {
    width: 120px;
  }

  .switch-wrapper {
    margin-left: 8px;
  }
`;

export default style;
